/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.18.0-39-gcbbeb71b-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TestLdapServerResponse interface.
 */
export function instanceOfTestLdapServerResponse(value) {
    if (!('success' in value) || value['success'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
export function TestLdapServerResponseFromJSON(json) {
    return TestLdapServerResponseFromJSONTyped(json, false);
}
export function TestLdapServerResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'success': json['success'],
        'message': json['message'],
        'baseDns': json['base_dns'] == null ? undefined : json['base_dns'],
    };
}
export function TestLdapServerResponseToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'success': value['success'],
        'message': value['message'],
        'base_dns': value['baseDns'],
    };
}
